export default "/assets/images/rookie-parent1.png?f457ae38f4192a1d5ac3ab5fb5529f6f";